import tokens from '@qkindex/design-tokens';

// Shared minimum for form fields and their adjacent actions; content may grow.
export const minimumInteractiveSize = tokens.minimumInteractiveSize;
